import { servicedeskResolutionManagementEntrypoint } from '@jira/servicedesk__resolution-management/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';

export const servicedeskResolutionManagementPageEntrypoint = createPageEntryPoint({
	main: servicedeskResolutionManagementEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
